import { render, staticRenderFns } from "./SidebarSummaryRow.vue?vue&type=template&id=d28fb5fc&scoped=true&"
import script from "./SidebarSummaryRow.vue?vue&type=script&lang=js&"
export * from "./SidebarSummaryRow.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSummaryRow.vue?vue&type=style&index=0&id=d28fb5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28fb5fc",
  null
  
)

export default component.exports